import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ShortObject } from '../../project-misc/data/project/short-json-object';
import { User } from 'projects/core/src/lib/login/data/user';
import {
  CabinetComplexityVariation
} from 'projects/app-misc/src/app/modules/reports/data/cabinet-complexity-variation';
import { ProjectStatus } from 'projects/app-misc/src/app/modules/project-misc/data/project/statuses/project-status';
import { CabinetRoom } from 'projects/app-misc/src/app/modules/reports/data/cabinet-room';

@JsonObject('model.CabinetReport')
export class CabinetReport extends AbstractModel {

  @JsonProperty(Number, 'id')
  id?: number;

  @JsonProperty(Boolean, 'assemblyReady')
  assemblyReady?: boolean;

  @JsonProperty(Boolean, 'jobDeliveryReady')
  jobDeliveryReady?: boolean;

  @JsonProperty(Boolean, 'qualityControlReady')
  qualityControlReady?: boolean;

    @JsonProperty(Number, 'cabinetId')
  cabinetId?: number;

  @JsonProperty(String, 'back')
  back?: string;

  @JsonProperty(String, 'cabinetName')
  cabinetName?: string;

  @JsonProperty(Number, 'cabinetStyle')
  cabinetStyle?: number;

    @JsonProperty(Number, 'cabinetType')
  cabinetType?: number;

  @JsonProperty(String, 'catalog')
  catalog?: string;

  @JsonProperty(String, 'complexityParams')
  complexityParams?: string;

  @JsonProperty(CabinetComplexityVariation, 'complexityVariation')
  complexityVariation?: CabinetComplexityVariation;

  @JsonProperty(Number, 'depth')
  depth?: number;

  @JsonProperty(Number, 'height')
  height?: number;

  @JsonProperty(Number, 'width')
  width?: number;

  @JsonProperty(Number, 'elevation')
  elevation?: number;

  @JsonProperty(String, 'hinge')
  hinge?: string;

  @JsonProperty(String, 'complexityParams')
  description?: string;

  @JsonProperty(String, 'leftEnd')
  leftEnd?: string;

  @JsonProperty(String, 'rightEnd')
  rightEnd?: string;

  @JsonProperty(Number, 'overallComplexity')
  overallComplexity?: number;

  @JsonProperty(Number, 'quantity')
  quantity?: number

  @JsonProperty(CabinetRoom, 'room')
  room?: CabinetRoom;

  @JsonProperty(ProjectStatus, 'status')
  status?: ProjectStatus;

}
